///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IUser = Meevo.Plugins.Reports.IUser;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import GenderEnum = Meevo.Model.GenderEnum;


    export class EmployeesCollection extends SmartMoverApiCollection<IUser> implements IApiCollection<IUser> {

        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }

        protected get url() {
            return 'Report/Employee';
        }

        constructor(connectedModel: ModelValueType[], items: IUser[] = [], options: ICollectionOptions<IUser> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                hierarchyId: null,
                branchId: null,
                objectStateEnumList: this.getObjectStateEnumList(options),
                employeeCategoryList: [],
                genderEnumList: [GenderEnum.Male, GenderEnum.Female, GenderEnum.Other, GenderEnum.NotSpecified],
                displayName: null,
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending'
            });
        }

        private getObjectStateEnumList(options) {
            if (!options || !options.criteria) {
                return [ObjectStateEnum.Active, ObjectStateEnum.Inactive];
            }

            var objectStateEnumList = [];

            if (options.criteria.includeActive) {
                objectStateEnumList.push(ObjectStateEnum.Active);
            }
            
            if (options.criteria.includeInactive) {
                objectStateEnumList.push(ObjectStateEnum.Inactive);
            }

            return objectStateEnumList;
        }
    }

}
